import * as types from '../types';
import { MUTATION_SET_ADVISOR_ACCOUNTS } from './types';

export default {
    [types.FUND_MUTATION_WITHDRAW_MODAL_OPEN]: (state, payload) => {
        //*
        // args:
        // payload: bool
        state.withdrawModalOpen = payload
    },
    [types.FUND_MUTATION_DEPOSIT_MODAL_OPEN]: (state, payload) => {
        // args:
        // payload: bool
        state.depositModalOpen = payload
    },
    [types.FUND_MUTATION_BULK_SET_PENDING_DEPOSIT_ATTRIBUTIONS]: (state, payload) => {
        // args:
        // payload: object
        state.pendingDepositAttributions = payload
    },
    [types.FUND_MUTATION_SET_CLIENT_TRADING_ACCOUNTS]: (state, payload) => {
        // args:
        // payload: object
        state.clientTradingAccounts = payload
    },
    [MUTATION_SET_ADVISOR_ACCOUNTS]: (state, data) => {
        state.advisorAccounts = data;
    },
}